@if (mode === 'local') {
  <!-- Floating Button -->
  <button
    (click)="toggle()"
    class="feedback-fab"
    [class.open]="isOpen"
    [title]="'FEEDBACK.TITLE' | translate"
  >
    <svg *ngIf="!isOpen" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
    </svg>
    <svg *ngIf="isOpen" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <line x1="18" y1="6" x2="6" y2="18"/>
      <line x1="6" y1="6" x2="18" y2="18"/>
    </svg>
  </button>

  <!-- Feedback Panel -->
  @if (isOpen) {
    <div class="feedback-panel">
      <div class="panel-header">
        <h3>{{ 'FEEDBACK.TITLE' | translate }}</h3>
        <span class="badge">DEV</span>
      </div>

      @if (!submitted) {
        <div class="panel-body">
          <div class="form-group">
            <label>{{ 'FEEDBACK.NAME' | translate }}</label>
            <input type="text" [(ngModel)]="feedback.submittedBy" [placeholder]="'FEEDBACK.NAME_PLACEHOLDER' | translate" />
          </div>

          <div class="form-row">
            <div class="form-group half">
              <label>{{ 'FEEDBACK.CATEGORY' | translate }}</label>
              <select [(ngModel)]="feedback.category">
                <option *ngFor="let c of categories" [value]="c.value">{{ c.label }}</option>
              </select>
            </div>
            <div class="form-group half">
              <label>{{ 'FEEDBACK.PRIORITY' | translate }}</label>
              <select [(ngModel)]="feedback.priority">
                <option *ngFor="let p of priorities" [value]="p.value">{{ p.label }}</option>
              </select>
            </div>
          </div>

          <div class="form-group">
            <label>{{ 'FEEDBACK.FIELD_TITLE' | translate }} <span class="required">*</span></label>
            <input type="text" [(ngModel)]="feedback.title" [placeholder]="'FEEDBACK.TITLE_PLACEHOLDER' | translate" />
          </div>

          <div class="form-group">
            <label>{{ 'FEEDBACK.DESCRIPTION' | translate }} <span class="required">*</span></label>
            <textarea [(ngModel)]="feedback.description" [placeholder]="'FEEDBACK.DESC_PLACEHOLDER' | translate" rows="4"></textarea>
          </div>

          <div class="form-group page-info">
            <span>{{ 'FEEDBACK.PAGE' | translate }} {{ feedback.page }}</span>
          </div>

          <button
            class="submit-btn"
            (click)="submit()"
            [disabled]="isSubmitting || !feedback.title || !feedback.description"
          >
            {{ isSubmitting ? ('FEEDBACK.SENDING' | translate) : ('FEEDBACK.SUBMIT' | translate) }}
          </button>
        </div>
      } @else {
        <div class="panel-body success">
          <div class="success-icon">&#10003;</div>
          <h4>{{ 'FEEDBACK.SENT' | translate }}</h4>
          <p>{{ 'FEEDBACK.THANK_YOU' | translate }}</p>
          <button class="submit-btn" (click)="submitted = false">{{ 'FEEDBACK.SEND_ANOTHER' | translate }}</button>
        </div>
      }
    </div>
  }
}
